import React from 'react';
import Header from '../components/Header';
import Pricing from '../components/Pricing';
import Footer from '../components/Footer';

const PricingPage = () => {
  return (
    <div className="pricing-page">
      <Header />
      <Pricing />
      <Footer />
    </div>
  );
};

export default PricingPage;